/*
 * Copyright (c) 2021. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';

import { CardTopViewModel } from 'src/types/view-models/card-top.view.model';

// components
import CardNameField from '../card-name-field/CardNameField';
import CardIcon from '../card-icon/CardIcon';

// stylesheets
import styles from './CardTop.module.scss';

export default class CardTop extends Component<CardTopViewModel> {
    public override render(): ReactComponentElement<any> {
        return (
            <div className={this.getClasses()}>
                <CardNameField
                    key="card-name-field"
                    card={this.props.card}
                    handleUpdateCard={this.props.handleUpdateCard}
                    handleChangeCard={this.props.handleChangeCard}
                    editingName={this.props.editingName}
                    toggleEditingName={this.props.toggleEditingName}
                />
                <CardIcon
                    card={this.props.card}
                    className="icon"
                    key="icon"
                    handleUpdateCard={this.props.handleUpdateCard}
                >
                    {this.props.icon}
                </CardIcon>
            </div>
        );
    }

    // get CSS classes
    private getClasses(): string {
        const classes: string[] = [];

        if (this.props.className) {
            classes.push(this.props.className);
        }

        classes.push(styles.cardTop);

        return classes.join(' ');
    }
}
